import {useCallback} from 'react'

import {NOTIFICATIONS} from '../notifications.js'

const useFavoriteLead = ({
  ad,
  analyticsTrack,
  domain,
  i18n,
  leadData,
  leadTypes,
  notify,
  pageName,
  seller,
  subscriptionCommitment,
  user
}) => {
  const handleFavoriteLeadConfirm = useCallback(async () => {
    const [contactError] = await domain.get('contact_seller_use_case').execute({
      adId: ad.id,
      contractId: seller?.contractId,
      context: pageName,
      name: user?.name,
      email: user?.email,
      phone: user?.phone,
      zipCode: user?.zipCode,
      message: i18n.t('LEAD_POST_FAVORITE.LEAD_MESSAGE'),
      hasAcceptedTermsAndConditions: true,
      isDefaultMessage: true,
      isPostFavoriteLead: true,
      skipSaveContactDetails: true,
      subscriptionCommitment
    })

    if (contactError) {
      notify(NOTIFICATIONS.LEAD_POST_FAVORITE_ERROR)
      return
    }

    notify(NOTIFICATIONS.LEAD_POST_FAVORITE_SUCCESS)

    analyticsTrack({
      event: 'Lead Triggered',
      data: {
        lead_type: leadTypes.DETAIL_FAVORITE_CHAT,
        ...leadData
      }
    })
  }, [
    ad.id,
    analyticsTrack,
    domain,
    i18n,
    leadData,
    leadTypes,
    notify,
    pageName,
    seller?.contractId,
    subscriptionCommitment,
    user
  ])

  return {handleFavoriteLeadConfirm}
}

export default useFavoriteLead
